import { Injectable, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type ToastType = 'success' | 'error';

export interface Toast {
  id: number;
  type: ToastType;
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  readonly toasts: WritableSignal<Toast[]> = signal<Toast[]>([]);

  private nextId: number = 0;
  private readonly timeOut: number = 5000;

  constructor(private translate: TranslateService) {}

  error(msg: string, title: string = 'error.error'): void {
    this.show('error', msg, title);
  }

  success(msg: string, title: string = 'success.success'): void {
    this.show('success', msg, title);
  }

  remove(id: number): void {
    this.toasts.update((toasts: Toast[]): Toast[] => toasts.filter((toast: Toast): boolean => toast.id !== id));
  }

  private show(type: ToastType, msg: string, title: string): void {
    this.translate.get([msg, title]).subscribe((res: any): void => {
      const id: number = ++this.nextId;

      this.toasts.update((toasts: Toast[]): Toast[] => [{ id: id, type: type, title: res[title], message: res[msg] }, ...toasts]);

      setTimeout((): void => this.remove(id), this.timeOut);
    });
  }

}
